import * as Icons from "react-feather";

const gettingStartedSection = [
  {
    href: "/documentation/welcome",
    icon: Icons["Shield"],
    title: "Welcome",
  },
  {
    href: "/documentation/getting-started",
    icon: Icons["Code"],
    title: "Getting Started",
  },
];

const complianceSection = [
  {
    href: "/documentation/policies-and-procedures",
    icon: Icons["Shield"],
    title: "Policies and Procedures",
    children: [
      {
        href: "/documentation/policies-and-procedures",
        title: "Overview",
      },
      {
        href: "/documentation/policies-and-procedures/notice-of-privacy-practices",
        title: "Notice of Privacy Practices",
      },
      {
        href: "/documentation/policies-and-procedures/notice-of-patient-rights-policy",
        title: "Notice of Patient Rights Policy",
      },
      {
        href: "/documentation/policies-and-procedures/use-and-disclosure-of-phi",
        title: "Use and Disclosure of PHI",
      },
      {
        href: "/documentation/policies-and-procedures/minimal-necessary-use-and-disclosure",
        title: "Minimum Necessary Use and Disclosure",
      },
      {
        href: "/documentation/policies-and-procedures/auth-requirements",
        title: "Authorization Requirements",
        children: [
          {
            href: "/documentation/policies-and-procedures/auth-requirements",
            title: "- Overview",
          },
          {
            href: "/documentation/policies-and-procedures/auth-requirements/authorization-forms",
            title: "- Authorization Form",
          },
          {
            href: "/documentation/policies-and-procedures/auth-requirements/authorization-exceptions",
            title: "- Authorization Exceptions",
          },
          {
            href: "/documentation/policies-and-procedures/auth-requirements/authorization-revocation",
            title: "- Authorization Revocation",
          },
        ],
      },
      {
        href: "/documentation/policies-and-procedures/business-associate-agreements",
        title: "Business Associate Agreements",
      },
      {
        href: "/documentation/policies-and-procedures/privacy-training-and-awareness",
        title: "Privacy Training and Awareness",
      },
      {
        href: "/documentation/policies-and-procedures/privacy-complaints-process",
        title: "Privacy Complaints Process",
      },
      {
        href: "/documentation/policies-and-procedures/private-breach-notification",
        title: "Privacy Breach Notification",
      },
      {
        href: "/documentation/policies-and-procedures/sanction-policy-for-privacy-violations",
        title: "Sanction Policy for Privacy Violations",
      },
      {
        href: "/documentation/policies-and-procedures/privacy-monitoring-and-auditing",
        title: "Privacy Monitoring and Auditing",
      },
    ],
  },
  {
    href: "/documentation/technical",
    icon: Icons["Shield"],
    title: "Technical Safeguards",
    children: [
      {
        href: "/documentation/technical/overview",
        title: "Overview",
      },
    ],
  },
  {
    href: "/documentation/physical",
    icon: Icons["Shield"],
    title: "Physical Safeguards",
    children: [
      {
        href: "/documentation/physical/overview",
        title: "Overview",
      },
    ],
  },
  {
    href: "/documentation/privacy",
    icon: Icons["Shield"],
    title: "Privacy Compliance",
    children: [
      {
        href: "/documentation/privacy/overview",
        title: "Overview",
      },
    ],
  },
  {
    href: "/documentation/breach-notification",
    icon: Icons["Shield"],
    title: "Breach Notification",
    children: [
      {
        href: "/documentation/breach-notification/overview",
        title: "Overview",
      },
    ],
  },
  {
    href: "/documentation/record-keeping",
    icon: Icons["Shield"],
    title: "Documentation and Records",
    children: [
      {
        href: "/documentation/record-keeping/overview",
        title: "Overview",
      },
    ],
  },
  {
    href: "/documentation/incident-response",
    icon: Icons["Shield"],
    title: "Incident Response",
    children: [
      {
        href: "/documentation/incident-response/overview",
        title: "Overview",
      },
    ],
  },
];

const developmentSection = [
  {
    href: "/documentation/routing",
    icon: Icons["ArrowRightCircle"],
    title: "Routing",
  },
  {
    href: "/documentation/auth",
    icon: Icons["Users"],
    title: "Authentication",
    children: [
      {
        href: "/documentation/auth/auth0",
        title: "Auth0",
      },
      {
        href: "/documentation/auth/cognito",
        title: "Cognito",
      },
      {
        href: "/documentation/auth/firebase",
        title: "Firebase",
      },
      {
        href: "/documentation/auth/jwt",
        title: "JWT",
      },
    ],
  },
  {
    href: "/documentation/guards",
    icon: Icons["Shield"],
    title: "Guards",
  },
  {
    href: "/documentation/theming",
    icon: Icons["Droplet"],
    title: "Theming",
  },
  {
    href: "/documentation/api-calls",
    icon: Icons["ArrowRightCircle"],
    title: "API Calls",
  },
  {
    href: "/documentation/redux",
    icon: Icons["ArrowRightCircle"],
    title: "Redux",
  },
  {
    href: "/documentation/internationalization",
    icon: Icons["Globe"],
    title: "Internationalization",
  },
  {
    href: "/documentation/environment-variables",
    icon: Icons["ArrowRightCircle"],
    title: "Environment Variables",
  },
  {
    href: "/documentation/eslint-and-prettier",
    icon: Icons["ArrowRightCircle"],
    title: "ESLint & Prettier",
  },
  {
    href: "/documentation/deployment",
    icon: Icons["ArrowRightCircle"],
    title: "Deployment",
  },
];

const supportSection = [
  {
    href: "/documentation/support",
    icon: Icons["Mail"],
    title: "Support",
  },
  {
    href: "/changelog",
    icon: Icons["List"],
    title: "Changelog",
    badge: "v4.2.1",
  },
];

const navItems = [
  {
    title: "Getting started",
    pages: gettingStartedSection,
  },
  {
    title: "Compliance and Security",
    pages: complianceSection,
  },
  {
    title: "Development",
    pages: developmentSection,
  },
  {
    title: "Help",
    pages: supportSection,
  },
];

export default navItems;
